<template>
  <transition name="fullscreen-modal-fade">
    <div v-if="visible" class="fullscreen-modal" @click.self="handleMaskClick">
      <div class="fullscreen-modal__container" :style="containerStyle">
        <div class="fullscreen-modal__header">
          <div class="fullscreen-modal__title">
            <slot name="title">{{ title }}</slot>
          </div>
          <div class="fullscreen-modal__actions">
            <slot name="actions"></slot>
            <button class="fullscreen-modal__close" @click="handleClose" title="ESC关闭">
              <i class="el-icon-close"></i>
            </button>
          </div>
        </div>
        <div class="fullscreen-modal__body" ref="modalBody">
          <slot></slot>
        </div>
        <div v-if="$slots.footer" class="fullscreen-modal__footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'FullscreenModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    closeOnClickModal: {
      type: Boolean,
      default: true
    },
    closeOnPressEscape: {
      type: Boolean,
      default: true
    },
    lockScroll: {
      type: Boolean,
      default: true
    },
    blurBackground: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    containerStyle() {
      return {
        width: this.width,
        height: this.height
      };
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.open();
      } else {
        this.close();
      }
    }
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    this.cleanup();
  },
  methods: {
    init() {
      if (this.visible) {
        this.open();
      }
    },
    open() {
      if (this.lockScroll) {
        document.body.style.overflow = 'hidden';
      }
      if (this.blurBackground) {
        document.body.classList.add('fullscreen-modal-open');
      }
      this.$nextTick(() => {
        this.$emit('open');
      });
      this.addEventListeners();
    },
    close() {
      if (this.lockScroll) {
        document.body.style.overflow = '';
      }
      document.body.classList.remove('fullscreen-modal-open');
      this.$emit('close');
      this.removeEventListeners();
    },
    handleClose() {
      this.$emit('update:visible', false);
      this.$emit('close');
    },
    handleMaskClick() {
      if (this.closeOnClickModal) {
        this.handleClose();
      }
    },
    handleKeydown(e) {
      if (e.key === 'Escape' && this.closeOnPressEscape && this.visible) {
        this.handleClose();
      }
    },
    addEventListeners() {
      document.addEventListener('keydown', this.handleKeydown);
    },
    removeEventListeners() {
      document.removeEventListener('keydown', this.handleKeydown);
    },
    cleanup() {
      this.removeEventListeners();
      document.body.style.overflow = '';
      document.body.classList.remove('fullscreen-modal-open');
    }
  }
};
</script>

<style scoped>
.fullscreen-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
}

.fullscreen-modal__container {
  display: flex;
  flex-direction: column;
  background-color: #f5f7fa;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  max-width: 100vw;
  max-height: 100vh;
}

.fullscreen-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  background-color: #fff;
  border-bottom: 1px solid #ebeef5;
  flex-shrink: 0;
}

.fullscreen-modal__title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  line-height: 1.4;
}

.fullscreen-modal__actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.fullscreen-modal__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
  color: #606266;
}

.fullscreen-modal__close:hover {
  background-color: #f5f7fa;
  color: #409eff;
}

.fullscreen-modal__close i {
  font-size: 20px;
}

.fullscreen-modal__body {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px;
}

.fullscreen-modal__body::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.fullscreen-modal__body::-webkit-scrollbar-thumb {
  background-color: #c0c4cc;
  border-radius: 4px;
}

.fullscreen-modal__body::-webkit-scrollbar-thumb:hover {
  background-color: #909399;
}

.fullscreen-modal__body::-webkit-scrollbar-track {
  background-color: #f5f7fa;
}

.fullscreen-modal__footer {
  padding: 16px 24px;
  background-color: #fff;
  border-top: 1px solid #ebeef5;
  flex-shrink: 0;
}

.fullscreen-modal-fade-enter-active,
.fullscreen-modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.fullscreen-modal-fade-enter-active .fullscreen-modal__container,
.fullscreen-modal-fade-leave-active .fullscreen-modal__container {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.fullscreen-modal-fade-enter,
.fullscreen-modal-fade-leave-to {
  opacity: 0;
}

.fullscreen-modal-fade-enter .fullscreen-modal__container,
.fullscreen-modal-fade-leave-to .fullscreen-modal__container {
  transform: scale(0.95);
  opacity: 0;
}
</style>